//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

export enum InstagramPostType {
  Post = 'post',
  Reels = 'reels',
  Story = 'story',
}

export const getInstagramPostTypeName = (postType: InstagramPostType) => {
  switch (postType) {
    case InstagramPostType.Post:
      return 'Feed Post';
    case InstagramPostType.Reels:
      return 'Reel';
    case InstagramPostType.Story:
      return 'Story';
  }
};
